"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOldPriceVisible = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const isOldPriceVisible = ({
  currentFormatted,
  old
}) => old != null && (0, _presentationUtils.parseNumberFromString)(old) > (0, _presentationUtils.parseNumberFromString)(currentFormatted);
exports.isOldPriceVisible = isOldPriceVisible;
